export const SECTION_IDS = [
    'account_statement',
    'au',
    'bigtionaer',
    'form_node',
    'inquiries',
    'mailbox',
    'meinebig',
    'osteo',
    'partner_area',
    'personal_data',
    'pzr',
] as const;

export interface SectionLockIdentifier {
    sectionId: SectionLockId;
    formNodeIds: string[];
    errorNode: {
        id: string;
        uuid: string;
        type: string;
    };
}

export type SectionLockId = (typeof SECTION_IDS)[number];
